// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"138":"c2a371ee","526":"e67a1a1d","581":"9a62da6e","690":"be8e3110","702":"6554144e","829":"7fcfa106"}[chunkId] + ".chunk.js";
};